module.exports = __webpack_public_path__ + "static/media/multiverse6.644de8f8.png";